import { getOptimizelyInstance } from './client_factory';
import { JAVASCRIPT_CLIENT_ENGINE } from './utils/enums';
/**
 * Creates an instance of the Optimizely class
 * @param  {Config} config
 * @return {Client|null} the Optimizely client object
 *                           null on error
 */
export const createInstance = function (config) {
    return getOptimizelyInstance(config);
};
export { createEventDispatcher } from './event_processor/event_dispatcher/event_dispatcher_factory';
export { createPollingProjectConfigManager } from './project_config/config_manager_factory.universal';
export { createForwardingEventProcessor, createBatchEventProcessor } from './event_processor/event_processor_factory.universal';
export { createOdpManager } from './odp/odp_manager_factory.universal';
// TODO: decide on vuid manager API for universal
// export { createVuidManager } from './vuid/vuid_manager_factory.node';
export * from './common_exports';
export const clientEngine = JAVASCRIPT_CLIENT_ENGINE;
export const __platforms = ['__universal__'];
//# sourceMappingURL=index.universal.js.map